@if (attachmentUploadState.uploadStatusByName.size) {
  <div class="mt-2">
    @for (upload of getUploadStatusValues(attachmentUploadState); track upload.file.name) {
      <app-attachment-status [uploadStatus]="upload"
                             [isFileClickable]="upload.associated"
                             [showProgressWhileAssociating]="autoAssociate"
                             [showItemCancel]="!disabled && !upload.associating"
                             (fileClickEvent)="onAttachmentOpen(upload)"
                             (removeEvent)="removeUpload(upload)"/>
    }
  </div>
  @if (showCancel && !disabled) {
    <div class="mt-1">
      <button type="button" class="btn btn-secondary btn-sm" (click)="cancelFiles()">{{'Cancel' | messageTranslate}}</button>
    </div>
  }
}